import React from 'react';
import { connect } from 'react-redux';
import {handleNotificationPermission} from '../redux/FeedbackRedux';


class NotificationsV2 extends React.Component {

	handleClick(event) {
		this.props.dispatch(handleNotificationPermission());
	}

	render () {
        return (
        <div
            className="notification-circle align-items-center justify-content-center d-flex"
            onClick={this.handleClick.bind(this)}
            data-toggle="tooltip"
            data-title={ this.props.state.notification_permission
                ? __('Browser notifications are already enabled. This means new Feedbacks and chat messages will trigger push notification pop-ups (and audible alerts) on your browser.')
                : __('Browser notifications are NOT currently enabled. To enable, click on the bell icon to allow your browser to receive push notification pop-ups (and audible alerts) when new Feedbacks and chat messages arrive.')}
        >

            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.0199 20.5299C9.68987 20.5299 7.35987 20.1599 5.14987 19.4199C4.30987 19.1299 3.66987 18.5399 3.38987 17.7699C3.09987 16.9999 3.19987 16.1499 3.65987 15.3899L4.80987 13.4799C5.04987 13.0799 5.26987 12.2799 5.26987 11.8099V8.91992C5.26987 5.19992 8.29987 2.16992 12.0199 2.16992C15.7399 2.16992 18.7699 5.19992 18.7699 8.91992V11.8099C18.7699 12.2699 18.9899 13.0799 19.2299 13.4899L20.3699 15.3899C20.7999 16.1099 20.8799 16.9799 20.5899 17.7699C20.2999 18.5599 19.6699 19.1599 18.8799 19.4199C16.6799 20.1599 14.3499 20.5299 12.0199 20.5299ZM12.0199 3.66992C9.12987 3.66992 6.76987 6.01992 6.76987 8.91992V11.8099C6.76987 12.5399 6.46987 13.6199 6.09987 14.2499L4.94987 16.1599C4.72987 16.5299 4.66987 16.9199 4.79987 17.2499C4.91987 17.5899 5.21987 17.8499 5.62987 17.9899C9.80987 19.3899 14.2399 19.3899 18.4199 17.9899C18.7799 17.8699 19.0599 17.5999 19.1899 17.2399C19.3199 16.8799 19.2899 16.4899 19.0899 16.1599L17.9399 14.2499C17.5599 13.5999 17.2699 12.5299 17.2699 11.7999V8.91992C17.2699 6.01992 14.9199 3.66992 12.0199 3.66992Z" fill="#fff"/>
                <path d="M13.8796 3.94018C13.8096 3.94018 13.7396 3.93018 13.6696 3.91018C13.3796 3.83018 13.0996 3.77018 12.8296 3.73018C11.9796 3.62018 11.1596 3.68018 10.3896 3.91018C10.1096 4.00018 9.80962 3.91018 9.61962 3.70018C9.42962 3.49018 9.36963 3.19018 9.47963 2.92018C9.88963 1.87018 10.8896 1.18018 12.0296 1.18018C13.1696 1.18018 14.1696 1.86018 14.5796 2.92018C14.6796 3.19018 14.6296 3.49018 14.4396 3.70018C14.2896 3.86018 14.0796 3.94018 13.8796 3.94018Z" fill="#fff"/>
                <path d="M12.0195 22.8101C11.0295 22.8101 10.0695 22.4101 9.36953 21.7101C8.66953 21.0101 8.26953 20.0501 8.26953 19.0601H9.76953C9.76953 19.6501 10.0095 20.2301 10.4295 20.6501C10.8495 21.0701 11.4295 21.3101 12.0195 21.3101C13.2595 21.3101 14.2695 20.3001 14.2695 19.0601H15.7695C15.7695 21.1301 14.0895 22.8101 12.0195 22.8101Z" fill="#fff"/>
            </svg>

        { this.props.state.notification_permission === false
            ?
                <div className="anim-pulse notification-badge align-items-center justify-content-center d-flex rounded-circle">
                    <i className="fas fa-exclamation text-white"></i>
                </div>
            :
                null
        }

        </div>
        );
	}
}

function mapStateToProps(state) {
	return { state:state }
}

export default connect(mapStateToProps)(NotificationsV2)
